export default "__VITE_ASSET__958103a4__"